import React from 'react';
import { useLocation } from 'react-router';

import { RHP } from 'providers';

import * as Styled from './StyledNavigation';
import useStartupCXI from '../../../useStartupCXI';

export const NavigationPage = ({ children, path }) => {
    const { vars } = useStartupCXI();
    const location = useLocation();

    const route = `/startup/${vars.startupId}/100-10-1/feedbacks${path}`;
    const active = location.pathname === route ? 'active' : '';

    const handleClick = () => RHP.push(route);

    return (
        <Styled.NavigationPage className={active} onClick={handleClick}>
            {children}
        </Styled.NavigationPage>
    );
};

export const Page = NavigationPage;
